import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/studentSidebar";
import {
  Calendar,
  momentLocalizer,
  View,
  ToolbarProps,
} from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./studentEvents.css";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import EditModal from "./components/editModal";
import { EventType } from "../../../types/events.type";
import { Button } from "antd";
import dayjs from "dayjs";
import cloneDeep from "lodash.clonedeep";
import { DATE_TIME_FORMAT } from "./constant";
import { useHandleCalendarEvents } from "../../../core/hooks/useHandleCalendarEvents";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { useAuth } from "../../../core/hooks/useAuth";
import { useTranslation } from "react-i18next";

const localizer = momentLocalizer(moment);

// Lấy ngày hiện tại
const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);

const StudentEvents = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isViewModal, setIsViewModal] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<EventType>({});
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState<View>("month");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState<string>("all");
  const [selectedDate, setSelectedDate] = useState({
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate(),
  });

  const { moodleUser } = useAuth();
  const { enrolledCourses, isEnrolledCoursesLoading } = useHandleCourses(
    moodleUser?.id
  );
  const handleEventParams = () => {
    if (selectedCourse === "all") {
      const params: any = {};
      enrolledCourses?.forEach((course: any, index: any) => {
        params[`events[courseids][${index}]`] = course.id;
      });
      return params;
    }
    return {
      "events[courseids][0]": selectedCourse
    };
  };

  const eventParams = handleEventParams()

  const { calendarEvents, isCalendarEventsLoading } =
    useHandleCalendarEvents(eventParams);
  const handleNavigate = (newDate: Date) => {
    setDate(newDate);
  };

  const handleViewChange = (newView: View) => {
    setView(newView);
  };

  const handleDateSelect = () => {
    const newDate = new Date(
      selectedDate.year,
      selectedDate.month,
      selectedDate.day
    );
    setDate(newDate);
    setShowDatePicker(false);
  };

  // Tạo mảng years từ 1900 đến 2100
  const years = Array.from({ length: 201 }, (_, i) => 1900 + i);
  const months = Array.from({ length: 12 }, (_, i) => i);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  // Custom Toolbar Component
  const CustomToolbar = (toolbar: ToolbarProps<EventType>) => {
    const goToToday = () => {
      const today = new Date();
      setSelectedDate({
        year: today.getFullYear(),
        month: today.getMonth(),
        day: today.getDate(),
      });
      toolbar.onNavigate("TODAY");
    };

    const goToBack = () => {
      const newDate = new Date(date);
      if (view === "month") {
        newDate.setMonth(newDate.getMonth() - 1);
      } else if (view === "week") {
        newDate.setDate(newDate.getDate() - 7);
      } else {
        newDate.setDate(newDate.getDate() - 1);
      }
      setSelectedDate({
        year: newDate.getFullYear(),
        month: newDate.getMonth(),
        day: newDate.getDate(),
      });
      toolbar.onNavigate("PREV");
    };

    const goToNext = () => {
      const newDate = new Date(date);
      if (view === "month") {
        newDate.setMonth(newDate.getMonth() + 1);
      } else if (view === "week") {
        newDate.setDate(newDate.getDate() + 7);
      } else {
        newDate.setDate(newDate.getDate() + 1);
      }
      setSelectedDate({
        year: newDate.getFullYear(),
        month: newDate.getMonth(),
        day: newDate.getDate(),
      });
      toolbar.onNavigate("NEXT");
    };

    const changeView = (view: View) => {
      toolbar.onView(view);
    };

    return (
      <div className="rbc-toolbar gap-3 gap-md-0">
        <div className="rbc-btn-group">
          <button type="button" onClick={goToBack}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
          <button type="button" onClick={goToToday}>
            {t('student.events.today')}
          </button>
          <button type="button" onClick={goToNext}>
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
          <button type="button" onClick={() => setShowDatePicker(true)}>
            {t('student.events.selectDate')}
          </button>
        </div>
        <div className="rbc-toolbar-label">{toolbar.label}</div>
        <div className="d-flex flex-column-reverse flex-md-row align-items-center gap-3">
          <select
            className="form-select"
            style={{ width: "200px" }}
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
          >
            <option value="all">{t('student.events.allCourses')}</option>
            {enrolledCourses?.map((course: any) => (
              <>
                <option value={course?.id}>{course?.fullname}</option>
              </>
            ))}
          </select>
          <div className="rbc-btn-group">
            <button
              type="button"
              className={toolbar.view === "month" ? "rbc-active" : ""}
              onClick={() => changeView("month")}
            >
              {t('student.events.month')}
            </button>
            <button
              type="button"
              className={toolbar.view === "week" ? "rbc-active" : ""}
              onClick={() => changeView("week")}
            >
              {t('student.events.week')}
            </button>
            <button
              type="button"
              className={toolbar.view === "day" ? "rbc-active" : ""}
              onClick={() => changeView("day")}
            >
              {t('student.events.day')}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const onSelectSlot = (slotInfo: any) => {
    setSelectedEvent((ev) => {
      const clonedSlot = cloneDeep(ev);
      clonedSlot.start = dayjs(slotInfo.start).format(
        DATE_TIME_FORMAT.YYYY_MM_DD
      );
      return clonedSlot;
    });
    setIsViewModal(false);
    setIsModalOpen(true);
  };

  const onSelectEvent = (eventInfo: any) => {
    setIsViewModal(true);
    setIsModalOpen(true);
    // Tìm lại event gốc dựa vào id (hoặc trường duy nhất)
    const originalEvent = calendarEvents?.find((ev: EventType) => ev.id === eventInfo.id) || eventInfo;
    const clonedEv = cloneDeep(originalEvent);
    clonedEv.start_time = dayjs(clonedEv.start).format(DATE_TIME_FORMAT.HH_mm);
    clonedEv.end_time = dayjs(clonedEv.end).format(DATE_TIME_FORMAT.HH_mm);
    setSelectedEvent(clonedEv);
  };

  const addEvent = () => {
    setIsViewModal(false);
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content">
        <div className="container">
          <ProfileCard />
          <div className="row">
            <StudentSidebar />
            <div className="col-lg-9">
              <Breadcrumb title={t('student.events.title')} />
              <div className="page-title d-flex align-items-center justify-content-between">
                <h5>{t('student.events.title')}</h5>
                <Button onClick={addEvent} type="primary">
                  {t('student.events.addEvent')}
                </Button>
              </div>
              <Calendar<EventType>
                localizer={localizer}
                events={calendarEvents?.map((ev: EventType) => ({ ...ev, end: ev.start }))}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
                view={view}
                onView={handleViewChange}
                date={date}
                onNavigate={handleNavigate}
                components={{
                  toolbar: CustomToolbar,
                }}
                onSelectSlot={onSelectSlot}
                onSelectEvent={onSelectEvent}
                selectable
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal chọn ngày */}
      {showDatePicker && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex={-1}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Chọn ngày</h5>
                <button
                  type="button"
                  className=" btn btn-close"
                  onClick={() => setShowDatePicker(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Năm</label>
                    <select
                      className="form-select"
                      value={selectedDate.year}
                      onChange={(e) =>
                        setSelectedDate({
                          ...selectedDate,
                          year: parseInt(e.target.value),
                        })
                      }
                    >
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Tháng</label>
                    <select
                      className="form-select"
                      value={selectedDate.month}
                      onChange={(e) =>
                        setSelectedDate({
                          ...selectedDate,
                          month: parseInt(e.target.value),
                        })
                      }
                    >
                      {months.map((month) => (
                        <option key={month} value={month}>
                          {month + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Ngày</label>
                    <select
                      className="form-select"
                      value={selectedDate.day}
                      onChange={(e) =>
                        setSelectedDate({
                          ...selectedDate,
                          day: parseInt(e.target.value),
                        })
                      }
                    >
                      {days.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDatePicker(false)}
                >
                  Đóng
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleDateSelect}
                >
                  Chọn
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showDatePicker && <div className="modal-backdrop fade show"></div>}
      <EditModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedEvent={selectedEvent}
        setSelectedEvent={setSelectedEvent}
        isViewModal={isViewModal}
      />
    </>
  );
};

export default StudentEvents;
